/**
 * Which endpoint generation serves an intent. Only `executeOperation` reads
 * this; callers never branch on it.
 */
export type RouteOpsStrategy = 'v2-pipeline' | 'v1-bulk' | 'v3-slot'

export const ROUTE_OPS_STRATEGIES: ReadonlyArray<RouteOpsStrategy> = ['v2-pipeline', 'v1-bulk', 'v3-slot'] as const

export const DEFAULT_ROUTE_OPS_STRATEGY: RouteOpsStrategy = 'v1-bulk'

/** Type guard — narrow an arbitrary string to `RouteOpsStrategy`. */
export const isRouteOpsStrategy = (value: unknown): value is RouteOpsStrategy =>
  typeof value === 'string' && (ROUTE_OPS_STRATEGIES as ReadonlyArray<string>).includes(value)
